import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import router from '@/router';

Vue.use(Vuex);
const filter = {
  namespaced: true,
  state: {
    filteringConditions: {
      startDate: null,
      endDate: null,
      filteringContracts: ['general', 'event', 'single'],
      filteringGeneralDumpReasons: ['General', 'Cleaning', 'Inventory', 'etc'],
      formattedMonthForGeneralFrom: null,
      formattedMonthForGeneralTo: null,
      minMonthForGeneral: null,
      maxMonthForGeneral: null,
      monthFromForGeneral: null,
      monthToForGeneral: null,
      allRangeForGeneral: true,
      filteringEventType: null,
      eventsForFiltering: null,
      filteringSelectedEvents: [],
      formattedMonthForEventFrom: null,
      formattedMonthForEventTo: null,
      minMonthForEvent: null,
      maxMonthForEvent: null,
      monthFromForEvent: null,
      monthToForEvent: null,
      allRangeForEvent: true,
      formattedEventMonthFrom: null,
      formattedEventMonthTo: null,
      eventMonthFrom: null,
      eventMonthTo: null,
      allRangeEvent: null,
      formattedMonthForSingleFrom: null,
      formattedMonthForSingleTo: null,
      minMonthForSingle: null,
      maxMonthForSingle: null,
      monthFromForSingle: null,
      monthToForSingle: null,
      allRangeForSingle: true,
    },
    totalSummary: null,
    co2Summary: null,
    insightItems: null
  },
  mutations: {
    setFilteringConditions(state, filteringConditions) {
      state.filteringConditions = filteringConditions
    },
    setTotalSummary(state, totalSummary) {
      state.totalSummary = totalSummary
    },
    setCo2Summary(state, co2Summary) {
      state.co2Summary = co2Summary
    },
    setInsightItems(state, insightItems) {
      state.insightItems = insightItems
    },
    clearFilteringConditions(state) {
      state.filteringConditions = null
      state.totalSummary = null
      state.co2Summary = null
      state.insightItems = null
    }
  },
  actions: {
    setFilteringConditions(context, filteringConditions) {
      // // 3つのプランのうち、絞り込み期間の両端を特定
      let fromDates = []
      if (filteringConditions.monthFromForGeneral) fromDates.push(filteringConditions.monthFromForGeneral)
      if (filteringConditions.monthFromForEvent) fromDates.push(filteringConditions.monthFromForEvent)
      if (filteringConditions.monthFromForSingle) fromDates.push(filteringConditions.monthFromForSingle)
      const currentDate = new Date();
      const lastYearDate = new Date();
      // 空の場合は100年前からデータ取得とする
      lastYearDate.setFullYear(currentDate.getFullYear() - 100)
      const oldestDate = fromDates.length != 0 ? fromDates
        .map(monthString => parseDate(monthString, 'start'))
        .reduce((oldest, current) => (current < oldest ? current : oldest)) : lastYearDate;
      let oldestDateStr = oldestDate.getFullYear() + "-" + ('00' + (oldestDate.getMonth() + 1)).slice(-2) + "-" + "01"
      let toDates = []
      if (filteringConditions.monthToForGeneral) toDates.push(filteringConditions.monthToForGeneral)
      if (filteringConditions.monthToForEvent) toDates.push(filteringConditions.monthToForEvent)
      if (filteringConditions.monthToForSingle) toDates.push(filteringConditions.monthToForSingle)
      // 空の場合は今日までのデータ取得とする
      const newestDate = toDates.length != 0 ? toDates
        .map(monthString => parseDate(monthString, 'end'))
        .reduce((newest, current) => (newest < current ? current : newest)) : new Date();
      let newestDateStr = newestDate.getFullYear() + "-" + ('00' + (newestDate.getMonth() + 1)).slice(-2) + "-" + ('00' + newestDate.getDate()).slice(-2)
      // 特定した両端の期間を保持
      filteringConditions.startDate = oldestDateStr
      filteringConditions.endDate = newestDateStr
      // filtering条件を保存
      context.commit('setFilteringConditions', filteringConditions);
      // summary情報を取得
      var params = new URLSearchParams();
      params.append('companyHash', filteringConditions.companyHash);
      filteringConditions.filteringContracts.forEach(filteringContract => params.append('plans', filteringContract.toUpperCase()));
      if (filteringConditions.filteringGeneralDumpReasons.length > 0) filteringConditions.filteringGeneralDumpReasons.forEach(filteringGeneralDumpReason => params.append('dumpReasons', filteringGeneralDumpReason));
      if (filteringConditions.monthFromForGeneral) params.append('generalReportStartDate', filteringConditions.monthFromForGeneral + "-" + "01");
      if (filteringConditions.monthToForGeneral) {
        const [monthToForGeneralYear, monthToForGeneralMonth] = filteringConditions.monthToForGeneral.split('-');
        const monthToForGeneral = new Date(parseInt(monthToForGeneralYear), parseInt(monthToForGeneralMonth), 0)
        params.append('generalReportEndDate', monthToForGeneral.getFullYear() + "-" + ('00' + (monthToForGeneral.getMonth() + 1)).slice(-2) + "-" + ('00' + monthToForGeneral.getDate()).slice(-2));
      }
      if (filteringConditions.monthFromForEvent) params.append('eventReportStartDate', filteringConditions.monthFromForEvent + "-" + "01");
      if (filteringConditions.monthToForEvent) {
        const [monthToForEventYear, monthToForEventMonth] = filteringConditions.monthToForEvent.split('-');
        const monthToForEvent = new Date(parseInt(monthToForEventYear), parseInt(monthToForEventMonth), 0)
        params.append('eventReportEndDate', monthToForEvent.getFullYear() + "-" + ('00' + (monthToForEvent.getMonth() + 1)).slice(-2) + "-" + ('00' + monthToForEvent.getDate()).slice(-2));
      }
      if (filteringConditions.monthFromForSingle) params.append('singleReportStartDate', filteringConditions.monthFromForSingle + "-" + "01");
      if (filteringConditions.monthToForSingle) {
        const [monthToForSingleYear, monthToForSingleMonth] = filteringConditions.monthToForSingle.split('-');
        const monthToForSingle = new Date(parseInt(monthToForSingleYear), parseInt(monthToForSingleMonth), 0)
        params.append('singleReportEndDate', monthToForSingle.getFullYear() + "-" + ('00' + (monthToForSingle.getMonth() + 1)).slice(-2) + "-" + ('00' + monthToForSingle.getDate()).slice(-2));
      }
      if (filteringConditions.filteringEventType == 'selectEvents' &&
        filteringConditions.filteringSelectedEvents &&
        filteringConditions.filteringSelectedEvents.length > 0) {
        params.append('eventContractIds', filteringConditions.eventsForFiltering.map(eventForFiltering => eventForFiltering.id));
      }
      // total summaryをget
      axios.get('/circular-insight/dashboard/total/summary', {
        headers: {
          'accept': '*/*'
        },
        params
      })
        .then(response => {
          // 取得したsummaryデータを保存
          context.commit('setTotalSummary', response.data.content);
        })
        .catch(err => {
          console.log(err)
          if (err.response.status == 401) {
            this.callAnotherAction()
            router.push({ path: '/login', query: { logout: true } })
          } else {
            router.push({ path: '/error/500' })
          }
        })
      // co2 summaryをget
      axios.get('/circular-insight/dashboard/co2-detail/summary', {
        headers: {
          'accept': '*/*'
        },
        params
      })
        .then(response => {
          // 取得したsummaryデータを保存
          context.commit('setCo2Summary', response.data.content);
        })
        .catch(err => {
          console.log(err)
          if (err.response.status == 401) {
            this.callAnotherAction()
            router.push({ path: '/login', query: { logout: true } })
          } else {
            router.push({ path: '/error/500' })
          }
        })
      // insight itemsをget
      axios.get('/circular-insight/dashboard/insight/items', {
        headers: {
          'accept': '*/*'
        }, params
      })
        .then(response => {
          // 取得したsummaryデータを保存
          context.commit('setInsightItems', response.data.content);
        })
        .catch(err => {
          this.handleError(err)
          if (err.response.status == 401) {
            this.callAnotherAction()
            router.push({ path: '/login', query: { logout: true } })
          } else {
            router.push({ path: '/error/500' })
          }
        })
    },
    callAnotherAction({ dispatch }) {
      dispatch("auth/logout")
    },
    clearFilteringConditions(context) {
      context.commit('clearFilteringConditions');
    }
  }
};

function parseDate(monthString, type) {
  const [year, month] = monthString.split('-');
  if (type == 'start') {
    return new Date(parseInt(year), parseInt(month) - 1);
  } else {
    return new Date(parseInt(year), parseInt(month), 0);
  }
}

export default filter
